"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStack = createStack;
function createStack() {
    const _stack = [];
    return {
        push(...items) {
            return _stack.push(...items);
        },
        pop() {
            return _stack.pop();
        },
        peek() {
            return _stack[_stack.length - 1];
        },
    };
}
